var _ = require('underscore');
// A generic binding that adds a keydown listener and calls all of the related
// callbacks when when a given key code is received. The value of this binding
// should be an object mapping names or comma separated strings of names for
// keys to the callback or array of callbacks that should be called when any of
// those keys are pressed.
//
// Example:
//
//   data-bind="keyboard: { up: previousItem, down: nextItem,
//                'tab,enter': selectItem, enter: [method1, method2] }"
//
// IDEA: Extend this to allow a + syntax that requires that two or more keys
// be pressed together in order to trigger the callback.
var namesToKeyCodes = {
  'up':       [38],
  'down':     [40],
  'left':     [37],
  'right':    [39],
  'tab':      [9],
  'enter':    [13],
  'escape':   [27],
  'shift':    [16],
  'control':  [17],
  'option':   [18],
  'command':  [91, 224]
};

var mapKeyCodesToCallbacks = function(namesToCallbacks) {
  var map = {};

  // Construct the map
  _.each(namesToCallbacks, function(callbacks, names) {
    _.each(names.split(','), function(name) {
      var keyCodes = namesToKeyCodes[name] || [];
      _.each(keyCodes, function(keyCode) {
        if (!map[keyCode])
          map[keyCode] = [];
        if (_.isArray(callbacks)) {
          map[keyCode] = map[keyCode].concat(callbacks);
        } else {
          map[keyCode].push(callbacks);
        }
      });
    });
  });

  // Ensure that each callback is only called once
  _.each(map, function(callbacks, keyCode) {
    map[keyCode] = _.uniq(callbacks);
  });

  return map;
};

module.exports = {
  init: function(element, valueAccessor, allBindingsAccessor, viewModel) {
    var map = mapKeyCodesToCallbacks(valueAccessor());
    $(element).keydown(function(e) {
      var callbacks = map[e.keyCode];
      if (callbacks) {
        var returnValues = _.map(callbacks, function(callback) {
          return callback.call(viewModel);
        });
        if (_.compact(returnValues).length < returnValues.length) e.preventDefault();
      }
    });
  }
};
